import { Box, Flex, Text } from "@chakra-ui/react";
import { Accordion } from "@morressier/alembic";
import ReviewTableScore from "../ReviewTableScore";
import FileComponent from "./FileComponent";
import RinggoldBadge from "../RinggoldBadge";
import { IAdjudicationFormSubmission, IEarlyAssessmentFormSubmission, IPeerReviewSubmissionScore } from "@publishing-engine/domain/models";
import AssessmentOptIns from "./AssessmentOptIns";
import { allKeysHaveValues } from "src/pages/MyTask/Assessments/hooks";

type AssessmentFeedbackAccordionProps = {
  assessment: IEarlyAssessmentFormSubmission | IAdjudicationFormSubmission,
  config: any;
  submissionScore: IPeerReviewSubmissionScore;
  additionalReference?: {
    exists: boolean;
    value: string;
  };
}
const AssessmentFeedbackAccordion = ({ assessment, config, submissionScore, additionalReference }: AssessmentFeedbackAccordionProps) => {
  const hasOptIns = assessment?.webOfScienceOptIn || assessment?.reviewerAnonymity || assessment?.peerReviewTransparency
  const isSubmissionScoresData = allKeysHaveValues(submissionScore)

  const accordionItems = [
    {
      title: (
        <Flex alignItems={'flex-start'} gap={2} marginLeft={2}>
          <Text textStyle="headingItem">Your Feedback</Text>
        </Flex>
      ),
      content: (
        <Flex direction={'column'} gap={6} marginLeft={2}>
          {isSubmissionScoresData && submissionScore && config && (
            <Box flexDirection="column">
              <Text textStyle="headingItem">Submission Scores</Text>
              <Box marginX={2} marginTop={4}>
                <ReviewTableScore
                  submissionScores={submissionScore}
                  reviewFieldConfig={config}
                />
              </Box>
            </Box>
          )}
          {(assessment?.feedbackForEditors || (assessment?.editorAttachments && assessment?.editorAttachments?.length > 0)
            || assessment?.recommendedReviewers?.exists) &&
            <>
              <Text textStyle="headingGroup">Communications For Editors</Text>
              {assessment?.feedbackForEditors &&
                <Flex gap={3} direction={'column'}>
                  <Text textStyle="headingItem">Feedback for Editors</Text>
                  <Text textStyle="textBody">
                    {assessment?.feedbackForEditors}
                  </Text>
                </Flex>}

              {assessment?.editorAttachments && assessment?.editorAttachments?.length > 0 && (
                <Flex flexDirection="column" gap={3}>
                  <Text textStyle={'headingItem'}>Attached Files</Text>
                  {assessment?.editorAttachments.map(file => (
                    <FileComponent file={file} />
                  ))}
                </Flex>
              )}

              <Flex gap={3} direction={'column'}>
                {assessment?.recommendedReviewers?.exists && (
                  <>
                    <Text textStyle="headingItem">Recommended Reviewers</Text>
                    {assessment?.recommendedReviewers?.value.map(
                      item => (
                        <Flex flexDirection="column" gap={2}>
                          <Text textStyle="headingItem">
                            {item.firstName} {item.lastName}
                          </Text>
                          <Flex gap={1} alignItems="center">
                            <Text
                              noOfLines={1}
                              overflow="hidden"
                              textOverflow="ellipsis"
                            >
                              {item.affiliation}
                            </Text>
                            {item.ringgoldId && <RinggoldBadge />}
                          </Flex>
                          <Text textStyle="textBody">{item.email}</Text>
                          <Text textStyle="textBody">{item.reason}</Text>
                        </Flex>
                      )
                    )}
                  </>
                )}
              </Flex>
            </>}


          {(assessment?.feedbackForAuthors ||
            (assessment?.authorsAttachments &&
              assessment?.authorsAttachments?.length >
              0)) && (
              <>
                <Text textStyle="headingGroup">Communications For Authors</Text>
                {assessment?.feedbackForAuthors && <Flex gap={3} direction={'column'}>
                  <Text textStyle="headingItem">Feedback for Authors</Text>
                  <Text textStyle="textBody">
                    {assessment?.feedbackForAuthors}
                  </Text>
                </Flex>}
                {assessment?.authorsAttachments && assessment?.authorsAttachments?.length > 0 && (
                  <Flex flexDirection="column" gap={3}>
                    <Text textStyle={'headingItem'}>Attached Files</Text>
                    {assessment?.authorsAttachments.map(file => (
                      <FileComponent file={file} />
                    ))}
                  </Flex>
                )}
              </>
            )}
          {additionalReference?.exists && (
            <Flex flexDirection="column" gap={2}>
              <Text textStyle="headingItem">
                Additional References
              </Text>
              <Text textStyle="textBody">{additionalReference?.value}</Text>
            </Flex>
          )}
        </Flex>
      )
    }
  ]

  if (hasOptIns) {
    accordionItems.push(
      {
        title: (
          <Flex alignItems={'flex-start'} gap={2} marginLeft={2}>
            <Text textStyle="headingItem">Opt Ins</Text>
          </Flex>
        ),
        content: (
          <>
            <AssessmentOptIns
              earlyAssessment={assessment}
              config={config}
            />
          </>
        )
      }
    )
  }

  return (
    assessment ?
      <Accordion
        chakraAccordionProps={{
          width: '100%',
          defaultIndex: [0],
          allowToggle: true
        }}
        items={accordionItems}
      />
      : <></>
  )
}

export default AssessmentFeedbackAccordion;